import React from 'react'

interface CheckItemProps {
  isSelected: boolean
  name: string
  price?: string
  icon?: string
  additionalText?: string
  action: base.BasicFunc
}

const CheckItem: React.FC<CheckItemProps> = ({ isSelected, name, price, icon, additionalText, action }) => {
  return (
    <div
      className='checkItem'
      onClick={action}>
      <div className={`circle${isSelected ? ' checked' : ''}`}>
        <i className='icon icon--check'></i>
      </div>
      <div className='checkItem__title'>
        <div>{name}</div>
        {additionalText && <div>{additionalText}</div>}
      </div>
      {price && <div className='price'>{price} zł</div>}
       {icon
          ? <div className='logo'>
            <i className={`icon--${icon}`} />
          </div>
          : null}
    </div>
  )
}

export default CheckItem